import { useState } from 'react';
import { Button, ButtonProps } from './Button';

type AsyncButtonProps = Omit<ButtonProps, 'onClick'> & {
  onClick: () => Promise<void>;
};

export const AsyncButton: React.FC<AsyncButtonProps> = ({
  onClick,
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      await onClick();
    } finally {
      setIsLoading(false);
    }
  };

  return <Button {...props} onClick={handleClick} loading={isLoading} />;
};
